import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AiChatBotService } from '@sparro/app/core/api/ai-chat-bot/ai-chat-bot.service';
import { SnackbarService } from '@sparro/app/core/helpers/toastr/snackbar.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { JournalService } from '@journal/app/core/api/journal/journal.service';

@Component({
  selector: 'app-ai-edits',
  templateUrl: './ai-edits.component.html',
  styleUrls: ['./ai-edits.component.scss']
})
export class AiEditsComponent implements OnInit {
  selectedString: string = null;
  editting: boolean = false;
  completion: string = null;
  prompt: string = null;

  operations: any = [
    {
      title: 'Edit or review selection',
      sections: [
        {
          title: 'Improve writing',
          prompt: 'Improve writing of this text'
        },
        {
          title: 'Fix spelling & grammar',
          prompt: 'Fix spelling and grammer in this'
        },
        {
          title: 'Make shorter',
          prompt: 'Make this text shorter'
        },
        {
          title: 'Make longer',
          prompt: 'Make this text longer'
        },
        {
          title: 'Change tone',
          prompt: 'Chnage tone of this text as',
          options: ['Professional', 'Casual', 'Straightforward', 'Confident', 'Friendly']
        },
        {
          title: 'Simplify language',
          prompt: 'Simplify the language of this text'
        }
      ]
    },
    {
      title: 'Generate from selection',
      sections: [
        {
          title: 'Summarize',
          prompt: 'Summarize this text'
        },
        {
          title: 'Explain this',
          prompt: 'Explain this text'
        },
        {
          title: 'Translate',
          prompt: 'Translate the language of this text into',
          options: [
            'English',
            'Spanish',
            'French',
            'German',
            'Italian',
            'Italian',
            'Italian',
            'Portuguese',
            'Dutch',
            'Russian',
            'Chinese (Simplified)',
            'Japanese',
            'Korean',
            'Arabic',
            'Hindi',
            'Bengali',
            'Tamil',
            'Telugu',
            'Urdu'
          ]
        }
      ]
    },
    {
      title: 'Write with AI',
      sections: [
        {
          title: 'Continue Writing',
          prompt: 'continue writing this text'
        },
        {
          title: 'Brainstorm ideas',
          prompt: 'generate Ideas using'
        },
        {
          title: 'Blog post',
          prompt: 'Create blog post using'
        },
        {
          title: 'Outline',
          prompt: 'Create outline using'
        },
        {
          title: 'Press release',
          prompt: 'Write a press release for this'
        },
        {
          title: 'Creative Story',
          prompt: 'Generate creative story for this'
        },
        {
          title: 'Essay',
          prompt: 'Write essay on this'
        }
      ]
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<AiEditsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clipboard: Clipboard,
    private chatService: AiChatBotService,
    private snackbarService: SnackbarService,
    public journalService: JournalService
  ) {}

  ngOnInit() {
    this.selectedString = this.data.range.toString();
    this.journalService.getCanEditUsingAi().subscribe(res => {
      if (!res) {
        this.snackbarService.error("Don't have required membership to use AI.");
        this.closeDialog();
      }
    });
  }

  editSelectedText(option: any = null, subtitle: string = null) {
    this.editting = true;
    this.prompt = `${option.prompt} ${subtitle ? subtitle : ''} \n\n"""${this.selectedString}"""`;
    const payload = {
      prompt: this.prompt
    };
    this.getCompletition(payload);
  }

  regenerate() {
    this.editting = true;
    const payload = {
      prompt: this.prompt
    };
    this.getCompletition(payload);
  }

  getCompletition(payload) {
    this.chatService.getEditedResponse(payload).subscribe(
      (response: any) => {
        // console.log(response, "here");
        this.completion = response.choices[0].text;
        this.editting = false;
      },
      err => {
        console.log(err), (this.editting = false);
        this.snackbarService.error('Something went wrong!');
      }
    );
  }

  closeDialog(operation: string = '') {
    this.dialogRef.close(
      this.completion ? { operation: operation, completion: this.completion } : null
    );
  }

  copiedReply(value) {
    this.clipboard.copy(value);
    this.snackbarService.success('Text copied to clipboard');
  }
}
